import React from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/material-kit.css";
import "../assets/css/styles.css";
import futuristicUiImg from "../assets/img/futuristic_ui_ripple_effect_new.gif";
import { Link } from "react-router-dom";

const SignIn = () => {
  const { t } = useTranslation();

  return (
    <div className="sign-in-basic">
      {/* Sign-in Section */}
      <div
        className="page-header align-items-center min-vh-100 d-flex justify-content-center"
        style={{
          backgroundImage: `url(${futuristicUiImg})`,
          backgroundSize: "cover",
        }}
      >
        <span className="mask bg-gradient-dark opacity-6"></span>
        <div className="container my-auto">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-8 col-sm-10 mx-auto">
              <div className="card z-index-0 fadeIn3 fadeInBottom">
                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                  <div className="bg-gradient-info shadow-info border-radius-lg py-3">
                    <h3 id="sign-in-title" className="text-white text-center mt-2 mb-0">
                      {t('signin.title')}
                    </h3>
                    <div className="row mt-3 justify-content-center">
                      <div className="col-3 text-center">
                        <Link className="btn btn-link px-3" to="#">
                          <i className="fa fa-facebook text-white text-lg"></i>
                        </Link>
                      </div>
                      <div className="col-3 text-center">
                        <Link className="btn btn-link px-3" to="#">
                          <i className="fa fa-github text-white text-lg"></i>
                        </Link>
                      </div>
                      <div className="col-3 text-center">
                        <Link className="btn btn-link px-3" to="#">
                          <i className="fa fa-google text-white text-lg"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="input-group input-group-outline my-3">
                    <label id="sign-in-email-label" className="form-label">
                      {t('signin.emailLabel')}
                    </label>
                    <input
                      id="sign-in-email-input"
                      type="email"
                      className="form-control"
                      placeholder=""
                    />
                  </div>
                  <div className="input-group input-group-outline mb-3">
                    <label id="sign-in-password-label" className="form-label">
                      {t('signin.passwordLabel')}
                    </label>
                    <input
                      id="sign-in-password-input"
                      type="password"
                      className="form-control"
                      placeholder=""
                    />
                  </div>
                  <div className="form-check form-switch d-flex align-items-center mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="rememberMe"
                      defaultChecked
                    />
                    <label
                      id="sign-in-remember-label"
                      className="form-check-label ms-3 mb-0"
                      htmlFor="rememberMe"
                    >
                      {t('signin.rememberMe')}
                    </label>
                  </div>
                  <div className="text-center">
                    <button
                      id="sign-in-button"
                      type="button"
                      className="btn bg-gradient-info w-100 my-4 mb-2"
                    >
                      {t('signin.button')}
                    </button>
                  </div>
                  <p className="mt-4 text-sm text-center">
                    <span id="no-account-text">{t('signin.noAccount')}</span>{" "}
                    <Link
                      id="sign-in-contact-link"
                      to="/contact-us"
                      className="text-info"
                    >
                      {t('signin.contactUs')}
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
